import { TransportFeed } from "../redux/types";

export function getTransportFeedState({
  selectedApi,
  requestedApi,
  feeds,
  isFetching,
  isError,
}: {
  selectedApi?: string | null;
  requestedApi?: string | null;
  feeds?: TransportFeed[];
  isFetching: boolean;
  isError: boolean;
}) {
  // Even currentData can still belong to the previous station on the render
  // before the selection effect starts the next request.
  const matches = !!selectedApi && selectedApi === requestedApi;
  return {
    feeds: matches && !isFetching && !isError ? feeds : undefined,
    isError:
      matches && !isFetching && (isError || feeds?.[0]?.resultOk === false),
  };
}
